import { render, staticRenderFns } from "./uploadAppendix.vue?vue&type=template&id=47f83b0d&scoped=true"
import script from "./uploadAppendix.vue?vue&type=script&lang=js"
export * from "./uploadAppendix.vue?vue&type=script&lang=js"
import style0 from "./uploadAppendix.vue?vue&type=style&index=0&id=47f83b0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f83b0d",
  null
  
)

export default component.exports